import React, {useState, useEffect} from 'react';
import {useParams, useHistory, NavLink} from 'react-router-dom';
import * as moment from 'moment';
import {useQuery, useMutation} from 'react-query';
import {
    Card,
    Table,
    Badge,
    Button as BSButton,
    Row,
    Col,
    Form,
    Tabs,
    Tab,
    Modal
} from 'react-bootstrap';
import {
    MAINTENANCE_BATCH_API,
    MAINTENANCE_EVENT_API,
    ASSET_API,
    MATERIALCATALOG_API,
    ASSETSTATUS_API,
    DEPARTMENT_API
} from '@app/utils/apiUrl';
import {Get, Put} from '@app/utils/httpProvider';
// import {formatDateTimeMoment} from '../../utils/helper';
import {toast} from 'react-toastify';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';
import ReactToPrint from 'react-to-print';
import MaintenanceBatchPrintTemplate from './MaintenanceBatchPrintTemplate';
import {useRef} from 'react';
import {URI_INTERNAL} from '../../utils/pathLocations';
import {getInfomationAccountFromToken} from '@app/utils/helper';
import {userManager} from '@app/utils/oidc';
import Select, {components} from 'react-select';
import DatePicker from 'react-datepicker';
import Pagination from 'react-js-pagination';
import {getRoleUser} from '@app/utils/httpClient';

const statusStyles = {
    'Đã phê duyệt': {
        background: '#059669',
        color: '#ffffff',
        border: 'none',
        icon: 'fa-check-circle'
    },
    'Đã sửa chữa': {
        background: '#2563eb',
        color: '#ffffff',
        border: 'none',
        icon: 'fa-wrench'
    },
    'Không phê duyệt': {
        background: '#dc2626',
        color: '#ffffff',
        border: 'none',
        icon: 'fa-times-circle'
    },
    'Chờ phê duyệt': {
        background: '#ffc107',
        color: '#000000',
        border: 'none',
        icon: 'fa-clock'
    },
    'Đang xử lý': {
        background: '#3b82f6',
        color: '#ffffff',
        border: 'none',
        icon: 'fa-wrench'
    },
    'Đã hoàn thành': {
        background: '#10b981',
        color: '#ffffff',
        border: 'none',
        icon: 'fa-check-double'
    }
};

const eventTypeOptions = [
    {value: 'Sửa chữa', label: 'Sửa chữa'},
    {value: 'Bảo dưỡng định kỳ', label: 'Bảo dưỡng định kỳ'},
    {value: 'Bảo hành', label: 'Bảo hành'},
    {value: 'Nâng cấp', label: 'Nâng cấp'}
];

const StatusBadge = ({status}) => {
    const displayStatus = status === 'Đang xử lý' ? 'Đang sửa chữa' : status;
    const getStyle = (statusName) => {
        if (!statusName)
            return {
                background: '#6b7280',
                color: '#ffffff',
                icon: 'fa-info-circle'
            };

        const lower = statusName.toLowerCase();
        if (lower === 'đã phê duyệt') return statusStyles['Đã phê duyệt'];
        if (lower === 'đã sửa chữa') return statusStyles['Đã sửa chữa'];
        if (lower === 'không phê duyệt') return statusStyles['Không phê duyệt'];
        if (lower === 'chờ phê duyệt') return statusStyles['Chờ phê duyệt'];
        if (lower === 'đang xử lý' || lower === 'đang sửa chữa') return statusStyles['Đang xử lý'];
        if (lower === 'đã hoàn thành') return statusStyles['Đã hoàn thành'];

        return {
            background: '#6b7280',
            color: '#ffffff',
            icon: 'fa-info-circle'
        };
    };

    const style = getStyle(status);

    return (
        <span
            className="badge shadow-sm d-inline-flex align-items-center justify-content-center"
            style={{
                padding: '4px 10px',
                borderRadius: '6px',
                fontSize: '11px',
                fontWeight: 700,
                background: style.background,
                color: style.color,
                whiteSpace: 'nowrap',
                textTransform: 'uppercase',
                minWidth: '135px',
                height: '24px',
                letterSpacing: '0.3px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
        >
            <i
                className={`fas ${style.icon} mr-1`}
                style={{fontSize: '10px'}}
            />
            {displayStatus}
        </span>
    );
};

const formatDateTimeMoment = (date) => {
    if (!date) return '—';
    const m = moment(new Date(date));
    return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : '—';
};

const repairResultOptions = [
    {
        value: 'Thành công',
        label: 'Thành công',
        color: '#10b981',
        icon: 'fa-check-circle'
    },
    {
        value: 'Thất bại',
        label: 'Thất bại',
        color: '#ef4444',
        icon: 'fa-times-circle'
    }
];

const resultSelectStyles = {
    control: (base, state) => ({
        ...base,
        borderRadius: '8px',
        borderColor: state.isFocused ? '#06b6d4' : '#e5e7eb',
        boxShadow: state.isFocused
            ? '0 0 0 3px rgba(6, 182, 212, 0.15)'
            : 'none',
        '&:hover': {
            borderColor: '#06b6d4'
        },
        padding: '2px 4px',
        fontSize: '14px',
        fontWeight: '600'
    }),
    option: (base, {data, isFocused, isSelected}) => ({
        ...base,
        backgroundColor: isSelected
            ? data.color
            : isFocused
            ? `${data.color}15`
            : 'transparent',
        color: isSelected ? 'white' : data.color,
        fontWeight: 'bold',
        cursor: 'pointer',
        padding: '10px 15px',
        '&:active': {
            backgroundColor: data.color,
            color: 'white'
        }
    }),
    singleValue: (base, {data}) => ({
        ...base,
        color: data.color,
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center'
    }),
    menu: (base) => ({
        ...base,
        borderRadius: '8px',
        boxShadow:
            '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        overflow: 'hidden',
        border: '1px solid #e5e7eb',
        marginTop: '8px'
    }),
    menuPortal: (base) => ({...base, zIndex: 999999})
};

const ResultOption = ({data, innerProps}) => (
    <div
        {...innerProps}
        className="d-flex align-items-center px-3 py-2"
        style={{
            cursor: 'pointer',
            backgroundColor: 'transparent',
            transition: 'all 0.2s'
        }}
    >
        <i
            className={`fas ${data.icon} mr-2`}
            style={{color: data.color, fontSize: '16px'}}
        />
        <span style={{color: data.color, fontWeight: 700}}>{data.label}</span>
    </div>
);

const ResultSingleValue = ({data}) => (
    <div className="d-flex align-items-center">
        <i
            className={`fas ${data.icon} mr-2`}
            style={{color: data.color, fontSize: '16px'}}
        />
        <span style={{color: data.color, fontWeight: 700}}>{data.label}</span>
    </div>
);

const MaintenanceBatchDetail = () => {
    const {id} = useParams();
    const history = useHistory();
    const componentRef = useRef();

    // --- State cho Inline Edit ---
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState('assets');
    const [batchTitle, setBatchTitle] = useState('');
    const [batchNotes, setBatchNotes] = useState('');
    const [performedBy, setPerformedBy] = useState('');
    const [batchType, setBatchType] = useState('Sửa chữa');
    const [errors, setErrors] = useState({});
    const [userRole, setUserRole] = useState('');
    const [currentUsername, setCurrentUsername] = useState('');

    const isAdmin = Array.isArray(userRole)
        ? userRole.some((r) => r.toLowerCase() === 'admin')
        : typeof userRole === 'string' && userRole.toLowerCase() === 'admin';

    const [confirmModal, setConfirmModal] = useState({
        show: false,
        title: '',
        message: '',
        type: 'primary',
        onConfirm: null
    });
    const [resultModal, setResultModal] = useState({
        show: false,
        eventId: null,
        isBatch: false
    }); 
    const [selectedRepairResult, setSelectedRepairResult] =
        useState('Thành công');
    const [rows, setRows] = useState([]);
    const [materials, setMaterials] = useState([]);

    // --- Pagination State ---
    const [assetPageSize, setAssetPageSize] = useState(10);
    const [materialPageSize, setMaterialPageSize] = useState(10);
    const [assetPage, setAssetPage] = useState(1);
    const [materialPage, setMaterialPage] = useState(1);
    const pageSizeOptions = [
        {value: 5, text: '5'},
        {value: 10, text: '10'},
        {value: 20, text: '20'},
        {value: 50, text: '50'}
    ];

    const {isLoading, data, refetch} = useQuery(
        ['maintenanceBatchDetail', id],
        () => Get(`${MAINTENANCE_BATCH_API.GET_ITEM}/${id}`),
        {
            onSuccess: (res) => {
                if (!res) return;
                // Sync data sang local state khi load xong
                setBatchTitle(res.title || '');
                setBatchNotes(res.notes || '');
                setPerformedBy(res.performedBy || '');
                setBatchType(res.batchType || 'Sửa chữa');

                const allLoadedMaterials = [];
                const loadedRows = (res.maintenanceEvents || []).map((e) => {
                    const localRowId = e.id || Date.now() + Math.random();
                    if (e.materials && e.materials.length > 0) {
                        e.materials.forEach((m) => {
                            allLoadedMaterials.push({
                                id: m.id || Date.now() + Math.random(),
                                rowId: localRowId,
                                materialCatalogId: m.materialCatalogId,
                                quantity: m.quantity || 1,
                                unitPrice: m.unitPrice || 0,
                                note: m.note || ''
                            });
                        });
                    }
                    return {
                        id: localRowId,
                        serverId: e.id,
                        assetId: e.assetId,
                        assetCode: e.assetCode,
                        assetName: e.assetName,
                        eventCode: e.eventCode || '',
                        eventName: e.eventName || '',
                        eventDate: e.eventDate
                            ? new Date(e.eventDate)
                            : new Date(),
                        endDate: e.endDate ? new Date(e.endDate) : null,
                        frequency: e.frequency || '',
                        performedBy: e.performedBy || '',
                        eventType: e.eventType || 'Sửa chữa',
                        deviceError: e.deviceError || '',
                        cost: e.cost || 0,
                        repairCount: e.repairCount || 1,
                        isInRepair: false,
                        status: e.status,
                        departmentName: e.departmentName,
                        repairResult: e.repairResult
                    };
                });
                setRows(loadedRows);
                setMaterials(allLoadedMaterials);
            }
        }
    );

    useEffect(() => {
        const fetchUser = async () => {
            const user = await userManager.getUser();
            if (user && user.profile) {
                const name = user.profile.preferred_username || user.profile.name || user.profile.username || '';
                setCurrentUsername(name);
            }
            
            const role = await getRoleUser();
            setUserRole(typeof role === 'string' ? role.toLowerCase() : role);
        };
        fetchUser();
    }, []);

    // --- Metadata Queries for Edit Mode ---
    const assetQuery = useQuery(
        ['assetsDataForBatch'],
        () => Get(ASSET_API.GET_PAGING, null, {PageIndex: 1, PageSize: 10000}),
        {enabled: isEditing}
    );
    const assetStatusQuery = useQuery(
        ['assetStatuses'],
        () =>
            Get(ASSETSTATUS_API.GET_PAGING, null, {
                PageIndex: 1,
                PageSize: 1000
            }),
        {enabled: isEditing}
    );
    const catalogQuery = useQuery(
        ['materialCatalog'],
        () =>
            Get(MATERIALCATALOG_API.GET_PAGING, null, {
                PageIndex: 1,
                PageSize: 1000
            }),
        {enabled: isEditing}
    );

    const departmentQuery = useQuery(
        ['departmentsDataForBatch'],
        () => Get(DEPARTMENT_API.GET_PAGING, null, {PageIndex: 1, PageSize: 1000}),
        {enabled: isEditing}
    );

    const departmentOptions =
        departmentQuery.data?.data?.map((d) => ({
            value: d.id,
            label: d.departmentName || d.name || ''
        })) || [];

    const assetOptions =
        assetQuery.data?.data?.map((a) => {
            const status = assetStatusQuery.data?.data?.find(
                (s) => s.id === a.assetStatusId
            );
            const statusName = status ? status.statusName : '';
            return {
                value: a.id,
                label: `${a.assetCode} - ${a.assetName} [${statusName}]`,
                assetCode: a.assetCode,
                statusName: statusName,
                departmentId: a.currentDepartmentId,
                departmentName: a.departmentName || a.department?.departmentName || '',
                isDisabled: statusName === 'Đang sửa chữa' || statusName === 'Điều chuyển' || statusName === 'Đang điều chuyển' || statusName === 'Chờ phê duyệt'
            };
        }) || [];

    const catalogOptions =
        catalogQuery.data?.data?.map((m) => ({
            value: m.id,
            label: `${m.materialCode || m.code || ''} - ${
                m.materialName || m.name || ''
            }`
        })) || [];

    // --- Mutations ---
    const approveFunc = useMutation((eventId) =>
        Put(`${MAINTENANCE_EVENT_API.APPROVE}/${eventId}`, null, {}, false)
    );
    const rejectFunc = useMutation((eventId) =>
        Put(`${MAINTENANCE_EVENT_API.REJECT}/${eventId}`, null, {}, false)
    );
    const completeFunc = useMutation((payload) =>
        Put(
            `${MAINTENANCE_EVENT_API.COMPLETE}/${payload.eventId}?repairResult=${payload.repairResult}`,
            null,
            {},
            false
        )
    );

    const approveBatchFunc = useMutation((batchId) =>
        Put(`${MAINTENANCE_BATCH_API.APPROVE}/${batchId}`, null, {}, false)
    );
    const unapproveBatchFunc = useMutation((batchId) =>
        Put(`${MAINTENANCE_BATCH_API.UNAPPROVE}/${batchId}`, null, {}, false)
    );
    const rejectBatchFunc = useMutation((batchId) =>
        Put(`${MAINTENANCE_BATCH_API.REJECT}/${batchId}`, null, {}, false)
    );
    const completeBatchFunc = useMutation((payload) =>
        Put(
            `${MAINTENANCE_BATCH_API.COMPLETE}/${payload.batchId}?repairResult=${payload.repairResult}`,
            null,
            {},
            false
        )
    );

    const updateBatchFunc = useMutation((submitData) =>
        Put(`${MAINTENANCE_BATCH_API.UPDATE}/${id}`, null, submitData)
    );

    // --- Handlers ---
    const handleSaveUpdate = async () => {
        let newErrors = {};
        if (!batchTitle) newErrors.batchTitle = 'Tiêu đề không được để trống';
        if (!performedBy)
            newErrors.performedBy = 'Người thực hiện không được để trống';

        const rowErrors = rows.map((r) => {
            let rowErr = {};
            if (!r.assetId) rowErr.assetId = 'Chọn tài sản';
            if (!r.eventName) rowErr.eventName = 'Nhập nội dung';
            return rowErr;
        });

        const rowInvalid = rowErrors.some((e) => Object.keys(e).length > 0);
        if (rowInvalid) newErrors.rows = rowErrors;

        const materialErrors = materials.map((m) => {
            let matErr = {};
            if (!m.materialCatalogId) matErr.materialCatalogId = 'Chọn vật tư';
            if (!m.quantity || m.quantity <= 0)
                matErr.quantity = 'Số lượng > 0';
            return matErr;
        });
        const matInvalid = materialErrors.some(
            (e) => Object.keys(e).length > 0
        );
        if (matInvalid) newErrors.materials = materialErrors;

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            toast.error('Vui lòng nhập đủ thông tin');
            return;
        }

        for (let i = 0; i < rows.length; i++) {
            const r = rows[i];
            if (!r.assetId) {
                toast.error(`Dòng ${i + 1}: Vui lòng chọn tài sản!`);
                return;
            }
            if (!r.eventName) {
                toast.error(`Dòng ${i + 1}: Vui lòng nhập nội dung sửa chữa!`);
                return;
            }
            if (r.isInRepair) {
                toast.error(
                    `Dòng ${
                        i + 1
                    }: Tài sản này đang trong quá trình sửa chữa hoặc chờ phê duyệt khác!`
                );
                return;
            }
            if (parseFloat(r.cost) < 0) {
                toast.error(`Dòng ${i + 1}: Chi phí không được nhỏ hơn 0!`);
                return;
            }
            if (
                r.endDate &&
                r.eventDate &&
                new Date(r.endDate).setHours(0, 0, 0, 0) <
                    new Date(r.eventDate).setHours(0, 0, 0, 0)
            ) {
                toast.error(
                    `Dòng ${
                        i + 1
                    }: Hạn hoàn thành không được nhỏ hơn ngày bắt đầu!`
                );
                return;
            }

            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (
                r.eventDate &&
                new Date(r.eventDate).setHours(0, 0, 0, 0) < today
            ) {
                toast.error(
                    `Dòng ${
                        i + 1
                    }: Ngày bắt đầu không được nhỏ hơn ngày hiện tại!`
                );
                return;
            }
        }

        const matPriceInvalid = materials.some(
            (m) => parseFloat(m.unitPrice) < 0 || parseFloat(m.quantity) < 0
        );
        if (matPriceInvalid) {
            toast.error('Số lượng và đơn giá vật tư không được nhỏ hơn 0!');
            return;
        }

        try {
            const maintenanceEvents = rows.map((r, index) => {
                // Chỉ gắn vật tư vào dòng đầu tiên (vật tư là chung cho cả phiếu)
                const finalMaterials =
                    index === 0
                        ? materials.map((m) => ({
                              id: 0,
                              materialCatalogId: m.materialCatalogId,
                              quantity: parseInt(m.quantity) || 1,
                              unitPrice: parseFloat(m.unitPrice) || 0,
                              note: m.note || ''
                          }))
                        : [];

                return {
                    assetId: parseInt(r.assetId),
                    eventCode: r.eventCode,
                    eventName: r.eventName,
                    description: r.eventName,
                    eventDate: r.eventDate,
                    endDate: r.endDate,
                    frequency: r.frequency || '',
                    performedBy: r.performedBy || '',
                    eventType: r.eventType || 'Sửa chữa',
                    deviceError: r.deviceError || '',
                    cost: parseFloat(r.cost) || 0,
                    repairCount: parseInt(r.repairCount) || 1,
                    materials: finalMaterials
                };
            });

            const submitData = {
                id: parseInt(id),
                batchCode: data.batchCode,
                title: batchTitle,
                notes: batchNotes,
                performedBy: performedBy,
                maintenanceEvents
            };

            updateBatchFunc.mutate(submitData, {
                onSuccess: () => {
                    toast.success('Cập nhật phiếu sửa chữa thành công!');
                    setIsEditing(false);
                    refetch();
                },
                onError: (err) => {
                    console.error('Lỗi khi cập nhật batch:', err);
                    toast.error(
                        err?.message ||
                            'Có lỗi xảy ra khi cập nhật (Xem console logs)'
                    );
                }
            });
        } catch (err) {
            toast.error('Có lỗi xảy ra!');
        }
    };

    const handleCancel = (e) => {
        if (e) e.preventDefault();
        const currentRelevantState = {
            title: batchTitle || '',
            notes: batchNotes || '',
            rows: rows.map((r) => ({
                assetId: String(r.assetId || ''),
                eventName: r.eventName || '',
                cost: String(r.cost || 0),
                materials: materials
                    .filter((m) => m.rowId === r.id)
                    .map((m) => ({
                        cat: String(m.materialCatalogId || ''),
                        qty: Number(m.quantity || 0)
                    }))
            }))
        };
        const originalRelevantState = {
            title: data?.title || '',
            notes: data?.notes || '',
            rows: (data?.maintenanceEvents || []).map((e) => ({
                assetId: String(e.assetId || ''),
                eventName: e.eventName || '',
                cost: String(e.cost || 0),
                materials: (e.materials || []).map((m) => ({
                    cat: String(m.materialCatalogId || ''),
                    qty: Number(m.quantity || 0)
                }))
            }))
        };
        const isDirty =
            JSON.stringify(currentRelevantState) !==
            JSON.stringify(originalRelevantState);

        if (!isDirty) {
            setIsEditing(false);
            return;
        }

        setConfirmModal({
            show: true,
            title: 'Hủy thay đổi',
            message:
                'Dữ liệu đã thay đổi! Bạn có chắc chắn muốn hủy và mất mọi thay đổi không?',
            type: 'warning',
            onConfirm: () => {
                setIsEditing(false);
                refetch();
            }
        });
    };

    const addRow = () => {
        setRows([
            ...rows,
            {
                id: Date.now() + Math.random(),
                serverId: null,
                departmentId: null,
                assetId: null,
                assetCode: '',
                assetName: '',
                eventCode: `EVT-${Math.floor(Date.now() / 1000)}`,
                eventName: '',
                eventDate: new Date(),
                endDate: null,
                frequency: '',
                performedBy: '',
                eventType: 'Sửa chữa',
                deviceError: '',
                cost: 0,
                repairCount: 1,
                isInRepair: false,
                status: 'Chờ phê duyệt'
            }
        ]);
    };

    const checkAssetStatus = (assetId, assetLabel, statusName) => {
        if (statusName === 'Đang sửa chữa') {
            toast.warning(
                `Tài sản [${assetLabel}] này đang có trạng thái "Đang sửa chữa". Vui lòng kiểm tra lại!`,
                {autoClose: 5000, position: 'top-center'}
            );
            return true;
        }
        if (statusName === 'Điều chuyển' || statusName === 'Đang điều chuyển') {
            toast.error(
                `Tài sản [${assetLabel}] này đang trong quá trình "Điều chuyển". Không thể thêm vào phiếu sửa chữa!`,
                {autoClose: 5000, position: 'top-center'}
            );
            return true;
        }
        if (statusName === 'Chờ phê duyệt') {
            toast.error(
                `Tài sản [${assetLabel}] này đang có trạng thái "Chờ phê duyệt" ở một phiếu sửa chữa khác. Không thể thêm tiếp!`,
                {autoClose: 5000, position: 'top-center'}
            );
            return true;
        }
        return false;
    };

    const removeRow = (rowId) => {
        if (rows.length > 1) {
            setRows(rows.filter((r) => r.id !== rowId));
            setMaterials(materials.filter((m) => m.rowId !== rowId));
        } else {
            toast.warn('Phải có ít nhất 1 dòng!');
        }
    };

    const updateRow = (rowId, field, value, extraData = null) => {
        let isInRepairValue = false;
        if (field === 'assetId' && value) {
            isInRepairValue = checkAssetStatus(
                value,
                extraData?.label || value,
                extraData?.statusName || ''
            );
        }
        setRows((prev) =>
            prev.map((r) =>
                r.id === rowId
                    ? {
                          ...r,
                          [field]: value,
                          departmentId:
                              field === 'assetId'
                                  ? (extraData?.departmentId || r.departmentId)
                                  : r.departmentId,
                          departmentName:
                              field === 'assetId'
                                  ? (extraData?.departmentName || '')
                                  : r.departmentName,
                          isInRepair:
                              field === 'assetId'
                                  ? isInRepairValue
                                  : r.isInRepair
                      }
                    : r
            )
        );
    };

    const handleDepartmentChange = (id, opt) => {
        setRows((prev) =>
            prev.map((r) =>
                r.id === id
                    ? {
                          ...r,
                          departmentId: opt?.value || null,
                          departmentName: opt?.label || '',
                          assetId: null,
                          isInRepair: false
                      }
                    : r
            )
        );
    };

    const addCommonMaterial = () => {
        setMaterials([
            ...materials,
            {
                id: Date.now() + Math.random(),
                rowId: rows[0]?.id || 0,
                materialCatalogId: null,
                quantity: 1,
                unitPrice: 0,
                note: ''
            }
        ]);
    };

    const updateMaterial = (id, field, value) => {
        setMaterials(
            materials.map((m) => (m.id === id ? {...m, [field]: value} : m))
        );
    };

    const removeMaterial = (id) => {
        setMaterials(materials.filter((m) => m.id !== id));
    };

    const handleApprove = (eventId) => {
        approveFunc.mutate(eventId, {
            onSuccess: () => {
                toast.success('Phê duyệt thành công!');
                refetch();
            },
            onError: (err) => toast.error(err?.message || 'Phê duyệt thất bại!')
        });
    };

    const handleReject = (eventId) => {
        if (window.confirm('Từ chối sữa chữa tài sản này?')) {
            rejectFunc.mutate(eventId, {
                onSuccess: () => {
                    toast.success('Đã từ chối!');
                    refetch();
                },
                onError: (err) =>
                    toast.error(err?.message || 'Thao tác thất bại!')
            });
        }
    };

    const handleApproveBatch = () => {
        setConfirmModal({
            show: true,
            title: 'Phê duyệt phiếu',
            message:
                'Bạn có chắc chắn muốn PHÊ DUYỆT toàn bộ thiết bị trong phiếu này?',
            type: 'success',
            icon: 'fa-check-circle',
            onConfirm: () => {
                approveBatchFunc.mutate(id, {
                    onSuccess: () => {
                        toast.success('Đã phê duyệt toàn bộ phiếu!');
                        refetch();
                    },
                    onError: (err) =>
                        toast.error(err?.message || 'Phê duyệt thất bại!')
                });
            }
        });
    };

    const handleUnapproveBatch = () => {
        setConfirmModal({
            show: true,
            title: 'Bỏ phê duyệt phiếu',
            message:
                'Bạn có chắc chắn muốn BỎ PHÊ DUYỆT phiếu này? Trạng thái sẽ quay về Chờ phê duyệt.',
            type: 'warning',
            icon: 'fa-undo',
            onConfirm: () => {
                unapproveBatchFunc.mutate(id, {
                    onSuccess: () => {
                        toast.success('Đã bỏ phê duyệt phiếu!');
                        refetch();
                    },
                    onError: (err) =>
                        toast.error(err?.message || 'Thao tác thất bại!')
                });
            }
        });
    };

    const handleRejectBatch = () => {
        setConfirmModal({
            show: true,
            title: 'Từ chối phiếu',
            message: 'Bạn có chắc chắn muốn TỪ CHỐI toàn bộ phiếu này?',
            type: 'danger',
            icon: 'fa-times-circle',
            onConfirm: () => {
                rejectBatchFunc.mutate(id, {
                    onSuccess: () => {
                        toast.success('Đã từ chối toàn bộ phiếu!');
                        refetch();
                    },
                    onError: (err) =>
                        toast.error(err?.message || 'Từ chối thất bại!')
                });
            }
        });
    };

    const handleCompleteBatch = () => {
        setSelectedRepairResult('Thành công');
        setResultModal({
            show: true,
            eventId: id,
            isBatch: true
        });
    };

    const handleComplete = (eventId) => {
        setSelectedRepairResult('Thành công');
        setResultModal({
            show: true,
            eventId: eventId,
            isBatch: false
        });
    };

    const handleUpdateResult = (item) => {
        const creator = data?.createdBy?.toLowerCase()?.trim();
        const currentUser = currentUsername?.toLowerCase()?.trim();

        // Chỉ cho phép admin hoặc người khởi tạo phiếu đổi kết quả
        if (!isAdmin && currentUser !== creator) {
            toast.warning('Chỉ người khởi tạo hoặc Admin mới có quyền đổi kết quả!');
            return;
        }
        
        setSelectedRepairResult(item.repairResult || 'Thành công');
        setResultModal({
            show: true,
            eventId: item.serverId,
            isBatch: false
        });
    };

    const handleFinalComplete = () => {
        if (resultModal.isBatch) {
            completeBatchFunc.mutate(
                {
                    batchId: resultModal.eventId,
                    repairResult: selectedRepairResult
                },
                {
                    onSuccess: () => {
                        toast.success('Đã hoàn thành toàn bộ phiếu sửa chữa!');
                        setResultModal({
                            show: false,
                            eventId: null,
                            isBatch: false
                        });
                        refetch();
                    },
                    onError: (err) =>
                        toast.error(err?.message || 'Thao tác thất bại!')
                }
            );
        } else {
            completeFunc.mutate(
                {
                    eventId: resultModal.eventId,
                    repairResult: selectedRepairResult
                },
                {
                    onSuccess: () => {
                        toast.success('Hoàn thành sửa chữa!');
                        setResultModal({
                            show: false,
                            eventId: null,
                            isBatch: false
                        });
                        refetch();
                    },
                    onError: (err) =>
                        toast.error(err?.message || 'Thao tác thất bại!')
                }
            );
        }
    };

    // Calculate Batch Status based on children
    const calculateBatchStatus = () => {
        if (!data?.maintenanceEvents || data.maintenanceEvents.length === 0)
            return data?.status || 'Đang xử lý';

        const allFinished = data.maintenanceEvents.every(
            (e) =>
                e.status === 'Đã sửa chữa' ||
                e.status === 'Không phê duyệt' ||
                e.status === 'Đã huỷ'
        );

        const allRejected = data.maintenanceEvents.every(
            (e) => e.status === 'Không phê duyệt' || e.status === 'Đã huỷ'
        );

        if (allRejected) return 'Không phê duyệt';
        if (allFinished) return 'Đã hoàn thành';
        return data.status || 'Đang xử lý';
    };

    const batchStatus = calculateBatchStatus();

    const totalAssetCost = rows.reduce(
        (sum, item) => sum + (parseFloat(item.cost) || 0),
        0
    );
    const totalMaterialCost = (materials || []).reduce(
        (sum, item) =>
            sum +
            (parseFloat(item.quantity) || 0) *
                (parseFloat(item.unitPrice) || 0),
        0
    );

    if (isLoading) return <ReactSpinner />;

    return (
        <div className="container-fluid py-3">
            {(approveFunc.isLoading ||
                rejectFunc.isLoading ||
                completeFunc.isLoading ||
                approveBatchFunc.isLoading ||
                rejectBatchFunc.isLoading ||
                updateBatchFunc.isLoading) && <ReactSpinner />}

            <Card className="shadow-sm border-0">
                <Card.Header className="bg-white py-3 border-bottom d-flex align-items-center">
                    <h5
                        className="mb-0 fw-bold text-primary"
                        style={{fontSize: '18px'}}
                    >
                        <i className="fas fa-file-invoice mr-2" /> Chi tiết
                        phiếu sửa chữa: {data?.batchCode}
                    </h5>
                    <div className="ml-auto d-flex align-items-center">
                        {/* Nhóm nút dành cho Chờ phê duyệt */}
                        {data?.status?.toLowerCase()?.trim() === 'chờ phê duyệt' && (
                            <>
                                {(data?.createdBy?.toLowerCase()?.trim() === currentUsername?.toLowerCase()?.trim() || isAdmin) && (
                                    <>
                                        {!isEditing ? (
                                            <BSButton
                                                variant="warning"
                                                size="sm"
                                                className="shadow-sm mr-2"
                                                onClick={() => setIsEditing(true)}
                                                style={{
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                    color: '#000'
                                                }}
                                            >
                                                <i className="fas fa-pencil-alt mr-1" />{' '}
                                                Chỉnh sửa
                                            </BSButton>
                                        ) : (
                                            <>
                                                <BSButton
                                                    variant="success"
                                                    size="sm"
                                                    className="shadow-sm mr-2"
                                                    onClick={handleSaveUpdate}
                                                    style={{
                                                        fontSize: '12px',
                                                        fontWeight: 600
                                                    }}
                                                >
                                                    <i className="fas fa-save mr-1" />{' '}
                                                    Cập nhật
                                                </BSButton>
                                                <BSButton
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    className="shadow-sm mr-2"
                                                    onClick={handleCancel}
                                                    style={{
                                                        fontSize: '12px',
                                                        fontWeight: 600
                                                    }}
                                                >
                                                    <i className="fas fa-times mr-1" />{' '}
                                                    Hủy
                                                </BSButton>
                                            </>
                                        )}
                                    </>
                                )}
                                {isAdmin && !isEditing && (
                                    <>
                                        <BSButton
                                            variant="success"
                                            size="sm"
                                            className="shadow-sm mr-2"
                                            onClick={handleApproveBatch}
                                            style={{
                                                fontSize: '12px',
                                                fontWeight: 600
                                            }}
                                        >
                                            <i className="fas fa-check mr-1" />{' '}
                                            Duyệt phiếu
                                        </BSButton>
                                        <BSButton
                                            variant="danger"
                                            size="sm"
                                            className="shadow-sm mr-2"
                                            onClick={handleRejectBatch}
                                            style={{
                                                fontSize: '12px',
                                                fontWeight: 600
                                            }}
                                        >
                                            <i className="fas fa-times mr-1" />{' '}
                                            Từ chối
                                        </BSButton>
                                    </>
                                )}
                            </>
                        )}

                        {/* Nhóm nút dành cho Đã phê duyệt / Đang sửa chữa */}
                        {isAdmin && !isEditing && data?.status?.toLowerCase()?.trim() === 'đang sửa chữa' && (
                            <BSButton
                                variant="outline-danger"
                                size="sm"
                                className="shadow-sm mr-2"
                                onClick={handleUnapproveBatch}
                                style={{
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    backgroundColor: '#fff'
                                }}
                            >
                                <i className="fas fa-undo mr-1" />{' '}
                                Bỏ phê duyệt
                            </BSButton>
                        )}

                        {/* Nút hoàn thành toàn bộ phiếu đã bị gỡ bỏ để bắt buộc người dùng xử lý từng thiết bị bên dưới */}
                        <div style={{display: 'none'}}>
                            <MaintenanceBatchPrintTemplate
                                ref={componentRef}
                                data={data}
                            />
                        </div>
                        <ReactToPrint
                            trigger={() => (
                                <BSButton
                                    variant="outline-info"
                                    size="sm"
                                    className="shadow-sm border mr-2 bg-white"
                                    style={{
                                        fontSize: '12px',
                                        color: '#17a2b8',
                                        fontWeight: 600
                                    }}
                                >
                                    <i className="fas fa-print mr-1" /> In phiếu
                                </BSButton>
                            )}
                            content={() => componentRef.current}
                        />
                        <BSButton
                            variant="outline-secondary"
                            size="sm"
                            className="shadow-sm border bg-white"
                            onClick={() =>
                                history.push(
                                    URI_INTERNAL.MAINTENANCE_BATCH_PATH
                                )
                            }
                            style={{fontSize: '12px', fontWeight: 600}}
                        >
                            <i className="fas fa-reply mr-1" /> Quay lại
                        </BSButton>
                    </div>
                </Card.Header>

                <Card.Body>
                    {/* --- Phần thông tin chung --- */}
                    <div className="mb-4">
                        <h6 className="text-secondary mb-3 d-flex align-items-center">
                            <span
                                className="bg-primary mr-2"
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '4px'
                                }}
                            >
                                <i
                                    className="fas fa-th-large text-white"
                                    style={{fontSize: '10px'}}
                                />
                            </span>
                            THÔNG TIN CHUNG
                        </h6>
                        <div className="pl-4 border-left ml-2">
                            <Row className="mb-4">
                                <Col md={2}>
                                    <div className="mb-3">
                                        <label className="text-muted small mb-1 d-block">
                                            Mã phiếu sửa chữa
                                        </label>
                                        <span
                                            className="fw-bold text-primary"
                                            style={{fontSize: '15px'}}
                                        >
                                            {data?.batchCode}
                                        </span>
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">
                                            Người khởi tạo
                                        </label>
                                        <span className="fw-bold">
                                            {data?.createdBy || 'admin'}
                                        </span>
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div className="mb-3">
                                        <label className="text-muted small mb-1 d-block">
                                            Người thực hiện
                                        </label>
                                        {!isEditing ? (
                                            <span
                                                className="fw-bold text-success"
                                                style={{fontSize: '15px'}}
                                            >
                                                {data?.performedBy || 'Chưa rõ'}
                                            </span>
                                        ) : (
                                            <>
                                                <Form.Control
                                                    size="sm"
                                                    value={performedBy}
                                                    onChange={(e) => {
                                                        setPerformedBy(
                                                            e.target.value
                                                        );
                                                        if (errors.performedBy)
                                                            setErrors({
                                                                ...errors,
                                                                performedBy:
                                                                    null
                                                            });
                                                    }}
                                                    placeholder="Tên người/đơn vị..."
                                                    isInvalid={
                                                        !!errors.performedBy
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.performedBy}
                                                </Form.Control.Feedback>
                                            </>
                                        )}
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">
                                            Loại (Kiểu sửa chữa)
                                        </label>
                                        {!isEditing ? (
                                            <span className="fw-bold text-info">
                                                {data?.batchType || 'Sửa chữa'}
                                            </span>
                                        ) : (
                                            <Select
                                                options={eventTypeOptions}
                                                value={eventTypeOptions.find(
                                                    (o) => o.value === batchType
                                                )}
                                                onChange={(opt) =>
                                                    setBatchType(opt.value)
                                                }
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: '31px',
                                                        fontSize: '13px'
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    })
                                                }}
                                            />
                                        )}
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div className="mb-3">
                                        <label className="text-muted small mb-1 d-block">
                                            Tiêu đề - Nội dung
                                        </label>
                                        {!isEditing ? (
                                            <span
                                                className="fw-bold"
                                                style={{fontSize: '15px'}}
                                            >
                                                {data?.title || 'Trống'}
                                            </span>
                                        ) : (
                                            <>
                                                <Form.Control
                                                    size="sm"
                                                    value={batchTitle}
                                                    onChange={(e) => {
                                                        setBatchTitle(
                                                            e.target.value
                                                        );
                                                        if (errors.batchTitle)
                                                            setErrors({
                                                                ...errors,
                                                                batchTitle: null
                                                            });
                                                    }}
                                                    placeholder="Nhập tiêu đề..."
                                                    isInvalid={
                                                        !!errors.batchTitle
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.batchTitle}
                                                </Form.Control.Feedback>
                                            </>
                                        )}
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">
                                            Trạng thái xử lý
                                        </label>
                                        <StatusBadge status={batchStatus} />
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className="mb-3">
                                        <label className="text-muted small mb-1 d-block">
                                            Thời gian tạo
                                        </label>
                                        <span className="text-dark font-weight-bold">
                                            {formatDateTimeMoment(
                                                data?.createdDate
                                            )}
                                        </span>
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">
                                            Số lượng thiết bị
                                        </label>
                                        <span className="fw-bold">
                                            <i className="fas fa-microchip mr-1 text-info" />
                                            {data?.maintenanceEvents?.length ||
                                                0}{' '}
                                            thiết bị
                                        </span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className="mb-3">
                                        <label className="text-muted small mb-1 d-block">
                                            Tổng chi phí dự kiến
                                        </label>
                                        <span
                                            className="fw-bold text-danger"
                                            style={{fontSize: '16px'}}
                                        >
                                            {data?.maintenanceEvents
                                                ?.reduce(
                                                    (sum, e) =>
                                                        sum + (e.cost || 0),
                                                    0
                                                )
                                                .toLocaleString('vi-VN')}{' '}
                                            đ
                                        </span>
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">
                                            Ghi chú
                                        </label>
                                        {!isEditing ? (
                                            <span className="text-dark">
                                                {data?.notes ||
                                                    'Không có ghi chú'}
                                            </span>
                                        ) : (
                                            <Form.Control
                                                size="sm"
                                                value={batchNotes}
                                                onChange={(e) =>
                                                    setBatchNotes(
                                                        e.target.value
                                                    )
                                                }
                                                placeholder="Nhập ghi chú..."
                                            />
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>

                    <div className="mt-4">
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(k) => setActiveTab(k)}
                            className="custom-tabs-minimal mb-3"
                        >
                            <Tab
                                eventKey="assets"
                                title={
                                    <span>
                                        <i className="fas fa-tools mr-2 text-info" />
                                        TÀI SẢN ({rows.length})
                                    </span>
                                }
                            >
                                <div className="mt-2">
                                    <Table responsive className="border">
                                        <thead
                                            className="bg-light text-secondary text-uppercase"
                                            style={{
                                                fontSize: '11px',
                                                letterSpacing: '0.5px'
                                            }}
                                        >
                                            <tr>
                                                <th
                                                    className="text-center py-2"
                                                    style={{width: '50px'}}
                                                >
                                                    #
                                                </th>
                                                <th
                                                    className="align-middle py-2"
                                                    style={{width: '200px'}}
                                                >
                                                    Khoa
                                                </th>
                                                <th
                                                    className="align-middle py-2"
                                                    style={{width: '250px'}}
                                                >
                                                    Tài sản / Thiết bị
                                                </th>
                                                <th
                                                    className="align-middle py-2"
                                                    style={{width: '200px'}}
                                                >
                                                    Lỗi thiết bị
                                                </th>
                                                <th className="align-middle py-2">
                                                    Nội dung sửa chữa
                                                </th>
                                                <th
                                                    className="align-middle py-2 text-center"
                                                    style={{width: '140px'}}
                                                >
                                                    Kết quả sửa chữa
                                                </th>
                                                <th
                                                    className="align-middle py-2"
                                                    style={{width: '130px'}}
                                                >
                                                    Ngày bắt đầu
                                                </th>
                                                <th
                                                    className="align-middle py-2"
                                                    style={{width: '130px'}}
                                                >
                                                    Hạn xong
                                                </th>
                                                <th
                                                    className="align-middle py-2"
                                                    style={{width: '120px'}}
                                                >
                                                    Chi phí
                                                </th>
                                                <th
                                                    className="align-middle py-2"
                                                    style={{width: '100px'}}
                                                >
                                                    Thao tác
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows
                                                .slice(
                                                    (assetPage - 1) *
                                                        assetPageSize,
                                                    assetPage * assetPageSize
                                                )
                                                .map((item, idx) => (
                                                    <React.Fragment
                                                        key={item.id || idx}
                                                    >
                                                        <tr>
                                                            <td className="text-center align-middle font-weight-light text-muted">
                                                                {idx +
                                                                    1 +
                                                                    (assetPage -
                                                                        1) *
                                                                        assetPageSize}
                                                            </td>
                                                            <td className="align-middle">
                                                                {isEditing ? (
                                                                    <Select
                                                                        options={departmentOptions}
                                                                        value={departmentOptions.find(o => o.value === (item.departmentId || assetOptions.find(a => a.value === item.assetId)?.departmentId))}
                                                                        onChange={(opt) => handleDepartmentChange(item.id, opt)}
                                                                        placeholder="Chọn khoa..."
                                                                        isClearable
                                                                        isDisabled={!!item.assetId}
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            control: (b) => ({
                                                                                ...b,
                                                                                minHeight: '31px',
                                                                                fontSize: '12px'
                                                                            }),
                                                                            menuPortal: (base) => ({
                                                                                ...base,
                                                                                zIndex: 9999
                                                                            })
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <div className="text-secondary small fw-bold">
                                                                        {item.departmentName || '—'}
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td className="align-middle">
                                                                {isEditing ? (
                                                                    <>
                                                                        <Select
                                                                            options={
                                                                                assetOptions.filter(a => {
                                                                                    const currDeptId = item.departmentId || assetOptions.find(opt => opt.value === item.assetId)?.departmentId;
                                                                                    return !currDeptId || a.departmentId === currDeptId;
                                                                                })
                                                                            }
                                                                            value={assetOptions.find(
                                                                                (
                                                                                    o
                                                                                ) =>
                                                                                    o.value ===
                                                                                    item.assetId
                                                                            )}
                                                                            onChange={(
                                                                                opt
                                                                            ) => {
                                                                                updateRow(
                                                                                    item.id,
                                                                                    'assetId',
                                                                                    opt?.value,
                                                                                    opt
                                                                                );
                                                                                if (
                                                                                    errors
                                                                                        .rows?.[
                                                                                        idx
                                                                                    ]
                                                                                        ?.assetId
                                                                                ) {
                                                                                    const newRowErrors =
                                                                                        [
                                                                                            ...errors.rows
                                                                                        ];
                                                                                    newRowErrors[
                                                                                        idx
                                                                                    ].assetId =
                                                                                        null;
                                                                                    setErrors(
                                                                                        {
                                                                                            ...errors,
                                                                                            rows: newRowErrors
                                                                                        }
                                                                                    );
                                                                                }
                                                                            }}
                                                                            placeholder="Chọn thiết bị..."
                                                                            isOptionDisabled={(option) => option.isDisabled}
                                                                            isClearable
                                                                            menuPortalTarget={
                                                                                document.body
                                                                            }
                                                                            styles={{
                                                                                control:
                                                                                    (
                                                                                        b
                                                                                    ) => ({
                                                                                        ...b,
                                                                                        minHeight:
                                                                                            '31px',
                                                                                        fontSize:
                                                                                            '12px',
                                                                                        borderColor:
                                                                                            errors
                                                                                                .rows?.[
                                                                                                idx
                                                                                            ]
                                                                                                ?.assetId
                                                                                                ? '#dc3545'
                                                                                                : b.borderColor,
                                                                                        '&:hover':
                                                                                            {
                                                                                                borderColor:
                                                                                                    errors
                                                                                                        .rows?.[
                                                                                                        idx
                                                                                                    ]
                                                                                                        ?.assetId
                                                                                                        ? '#dc3545'
                                                                                                        : b.borderColor
                                                                                            }
                                                                                    }),
                                                                                menuPortal:
                                                                                    (
                                                                                        base
                                                                                    ) => ({
                                                                                        ...base,
                                                                                        zIndex: 9999
                                                                                    }),
                                                                                option: (base, state) => ({
                                                                                    ...base,
                                                                                    color: state.isDisabled ? '#dc3545' : base.color,
                                                                                    backgroundColor: state.isDisabled ? '#fff3f3' : (state.isFocused ? '#e9ecef' : base.backgroundColor),
                                                                                    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
                                                                                    opacity: 1
                                                                                })
                                                                            }}
                                                                        />
                                                                        {errors
                                                                            .rows?.[
                                                                            idx
                                                                        ]
                                                                            ?.assetId && (
                                                                            <div className="text-danger small mt-1">
                                                                                {
                                                                                    errors
                                                                                        .rows[
                                                                                        idx
                                                                                    ]
                                                                                        .assetId
                                                                                }
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div
                                                                            className="fw-bold text-primary mb-0"
                                                                            style={{
                                                                                fontSize:
                                                                                    '14px'
                                                                            }}
                                                                        >
                                                                            {item.assetCode ||
                                                                                assetOptions.find(
                                                                                    (
                                                                                        o
                                                                                    ) =>
                                                                                        o.value ===
                                                                                        item.assetId
                                                                                )
                                                                                    ?.assetCode}
                                                                        </div>
                                                                        <div className="text-secondary small">
                                                                            {item.assetName ||
                                                                                assetOptions
                                                                                    .find(
                                                                                        (
                                                                                            o
                                                                                        ) =>
                                                                                            o.value ===
                                                                                            item.assetId
                                                                                    )
                                                                                    ?.label?.split(
                                                                                        ' - '
                                                                                    )[1]}
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </td>
                                                            <td className="align-middle text-dark">
                                                                {isEditing ? (
                                                                    <Form.Control
                                                                        size="sm"
                                                                        value={
                                                                            item.deviceError ||
                                                                            ''
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            updateRow(
                                                                                item.id,
                                                                                'deviceError',
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                        placeholder="Lỗi..."
                                                                    />
                                                                ) : (
                                                                    <div className="text-muted small">
                                                                        {item.deviceError ||
                                                                            '—'}
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td className="align-middle text-dark">
                                                                {isEditing ? (
                                                                    <>
                                                                        <Form.Control
                                                                            size="sm"
                                                                            value={
                                                                                item.eventName
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) => {
                                                                                updateRow(
                                                                                    item.id,
                                                                                    'eventName',
                                                                                    e
                                                                                        .target
                                                                                        .value
                                                                                );
                                                                                if (
                                                                                    errors
                                                                                        .rows?.[
                                                                                        idx
                                                                                    ]
                                                                                        ?.eventName
                                                                                ) {
                                                                                    const newRowErrors =
                                                                                        [
                                                                                            ...errors.rows
                                                                                        ];
                                                                                    newRowErrors[
                                                                                        idx
                                                                                    ].eventName =
                                                                                        null;
                                                                                    setErrors(
                                                                                        {
                                                                                            ...errors,
                                                                                            rows: newRowErrors
                                                                                        }
                                                                                    );
                                                                                }
                                                                            }}
                                                                            placeholder="Nội dung..."
                                                                            isInvalid={
                                                                                !!errors
                                                                                    .rows?.[
                                                                                    idx
                                                                                ]
                                                                                    ?.eventName
                                                                            }
                                                                        />
                                                                        <Form.Control.Feedback
                                                                            type="invalid"
                                                                            className="small"
                                                                        >
                                                                            {
                                                                                errors
                                                                                    .rows?.[
                                                                                    idx
                                                                                ]
                                                                                    ?.eventName
                                                                            }
                                                                        </Form.Control.Feedback>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div
                                                                            className="fw-bold"
                                                                            style={{
                                                                                fontSize:
                                                                                    '13px'
                                                                            }}
                                                                        >
                                                                            {
                                                                                item.eventName
                                                                            }
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </td>
                                                            <td className="align-middle pt-2">
                                                                <div className="text-center">
                                                                        {item.status ===
                                                                            'Đã hoàn thành' ||
                                                                        item.status ===
                                                                            'Đã sửa chữa' ? (
                                                                            <Badge
                                                                                className="shadow-sm border"
                                                                                onClick={() => handleUpdateResult(item)}
                                                                                title={(isAdmin || currentUsername?.toLowerCase()?.trim() === data?.createdBy?.toLowerCase()?.trim()) ? "Click để đổi kết quả" : ""}
                                                                                style={{
                                                                                    fontSize:
                                                                                        '11px',
                                                                                    minWidth:
                                                                                        '100px',
                                                                                    padding:
                                                                                        '6px 10px',
                                                                                    borderRadius:
                                                                                        '20px',
                                                                                    backgroundColor:
                                                                                        item.repairResult ===
                                                                                        'Thành công'
                                                                                            ? '#28a745'
                                                                                            : item.repairResult ===
                                                                                              'Thất bại'
                                                                                            ? '#dc3545'
                                                                                            : '#6c757d',
                                                                                    color: '#fff',
                                                                                    display:
                                                                                        'inline-flex',
                                                                                    alignItems:
                                                                                        'center',
                                                                                    justifyContent:
                                                                                        'center',
                                                                                    border: 'none',
                                                                                    cursor: (isAdmin || currentUsername?.toLowerCase()?.trim() === data?.createdBy?.toLowerCase()?.trim()) ? 'pointer' : 'default'
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className={`fas ${
                                                                                        item.repairResult ===
                                                                                        'Thành công'
                                                                                            ? 'fa-check'
                                                                                            : item.repairResult ===
                                                                                              'Thất bại'
                                                                                            ? 'fa-times'
                                                                                            : 'fa-clock'
                                                                                    } mr-1`}
                                                                                />
                                                                                {item.repairResult ||
                                                                                    'Thành công'}
                                                                            </Badge>
                                                                    ) : (
                                                                        <span className="text-muted small italic">
                                                                            —
                                                                            Chưa
                                                                            có —
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </td>

                                                            <td
                                                                className="text-center align-middle text-dark"
                                                                style={{
                                                                    fontSize:
                                                                        '12.5px'
                                                                }}
                                                            >
                                                                {isEditing ? (
                                                                    <DatePicker
                                                                        selected={
                                                                            item.eventDate
                                                                        }
                                                                        onChange={(
                                                                            date
                                                                        ) =>
                                                                            updateRow(
                                                                                item.id,
                                                                                'eventDate',
                                                                                date
                                                                            )
                                                                        }
                                                                        dateFormat="dd/MM/yyyy"
                                                                        minDate={
                                                                            new Date()
                                                                        }
                                                                        className="form-control form-control-sm text-center"
                                                                    />
                                                                ) : item.eventDate ? (
                                                                    formatDateTimeMoment(
                                                                        item.eventDate
                                                                    )
                                                                ) : (
                                                                    '—'
                                                                )}
                                                            </td>
                                                            <td
                                                                className="text-center align-middle text-dark"
                                                                style={{
                                                                    fontSize:
                                                                        '12.5px'
                                                                }}
                                                            >
                                                                {isEditing ? (
                                                                    <DatePicker
                                                                        selected={
                                                                            item.endDate
                                                                        }
                                                                        onChange={(
                                                                            date
                                                                        ) =>
                                                                            updateRow(
                                                                                item.id,
                                                                                'endDate',
                                                                                date
                                                                            )
                                                                        }
                                                                        dateFormat="dd/MM/yyyy"
                                                                        minDate={
                                                                            item.eventDate
                                                                        }
                                                                        className="form-control form-control-sm text-center"
                                                                    />
                                                                ) : item.endDate ? (
                                                                    <div className="d-flex flex-column align-items-center">
                                                                        <span>
                                                                            {formatDateTimeMoment(
                                                                                item.endDate
                                                                            )}
                                                                        </span>
                                                                        {(item.status ===
                                                                            'Chờ phê duyệt' ||
                                                                            item.status ===
                                                                                'Đang xử lý' ||
                                                                            item.status ===
                                                                                'Đang sửa chữa') &&
                                                                            new Date(
                                                                                item.endDate
                                                                            ).setHours(
                                                                                23,
                                                                                59,
                                                                                59,
                                                                                999
                                                                            ) <
                                                                                new Date() && (
                                                                                <span
                                                                                    className="badge bg-danger text-white mt-1 shadow-sm"
                                                                                    style={{
                                                                                        fontSize:
                                                                                            '10px'
                                                                                    }}
                                                                                >
                                                                                    <i className="fas fa-exclamation-triangle mr-1"></i>{' '}
                                                                                    Quá
                                                                                    hạn
                                                                                </span>
                                                                            )}
                                                                    </div>
                                                                ) : (
                                                                    '—'
                                                                )}
                                                            </td>
                                                            <td
                                                                className="text-right align-middle fw-bold text-dark"
                                                                style={{
                                                                    fontSize:
                                                                        '13.5px'
                                                                }}
                                                            >
                                                                {isEditing ? (
                                                                    <Form.Control
                                                                        type="number"
                                                                        size="sm"
                                                                        min={0}
                                                                        value={
                                                                            item.cost
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            updateRow(
                                                                                item.id,
                                                                                'cost',
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <>
                                                                        {item.cost?.toLocaleString(
                                                                            'vi-VN'
                                                                        )}{' '}
                                                                        <span className="text-muted small">
                                                                            đ
                                                                        </span>
                                                                    </>
                                                                )}
                                                            </td>
                                                            <td className="text-center align-middle">
                                                                {isEditing ? (
                                                                    <BSButton
                                                                        variant="link"
                                                                        className="text-danger p-0"
                                                                        title="Xóa"
                                                                        onClick={() =>
                                                                            removeRow(
                                                                                item.id
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="fas fa-trash-alt" />
                                                                    </BSButton>
                                                                ) : (
                                                                    <div className="d-flex justify-content-center">
                                                                        {item.status ===
                                                                            'Đã sửa chữa' && (
                                                                            <i
                                                                                className="fas fa-check-circle text-success"
                                                                                title="Đã xong"
                                                                                style={{
                                                                                    fontSize:
                                                                                        '18px'
                                                                                }}
                                                                            />
                                                                        )}
                                                                        {item.status ===
                                                                            'Không phê duyệt' && (
                                                                            <i
                                                                                className="fas fa-ban text-danger"
                                                                                title="Không phê duyệt"
                                                                                style={{
                                                                                    fontSize:
                                                                                        '18px'
                                                                                }}
                                                                            />
                                                                        )}
                                                                        {item.status ===
                                                                            'Chờ phê duyệt' && (
                                                                            <i
                                                                                className="fas fa-hourglass-half text-warning"
                                                                                title="Chờ phê duyệt"
                                                                                style={{
                                                                                    fontSize:
                                                                                        '18px'
                                                                                }}
                                                                            />
                                                                        )}
                                                                        {(item.status ===
                                                                            'Đang xử lý' ||
                                                                            item.status ===
                                                                                'Đã phê duyệt') &&
                                                                            (isAdmin ||
                                                                                currentUsername?.toLowerCase()?.trim() ===
                                                                                    data?.createdBy?.toLowerCase()?.trim()) && (
                                                                            <BSButton
                                                                                variant="link"
                                                                                size="sm"
                                                                                className="p-0"
                                                                                title="Xác nhận hoàn thành"
                                                                                onClick={() =>
                                                                                    handleComplete(
                                                                                        item.serverId
                                                                                    )
                                                                                }
                                                                            >
                                                                                <i
                                                                                    className="fas fa-wrench text-info"
                                                                                    style={{
                                                                                        fontSize:
                                                                                            '18px'
                                                                                    }}
                                                                                />
                                                                            </BSButton>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                            {rows.length === 0 && !isEditing && (
                                                <tr>
                                                    <td
                                                        colSpan="10"
                                                        className="text-center py-4 text-muted fst-italic"
                                                    >
                                                        Không có dữ liệu thiết
                                                        bị
                                                    </td>
                                                </tr>
                                            )}
                                            {rows.length > 0 && (
                                                <tr className="bg-light shadow-sm">
                                                    <td
                                                        colSpan="10"
                                                        className="text-center py-2 text-uppercase fw-bold"
                                                        style={{
                                                            fontSize: '15px',
                                                            color: '#dc2626',
                                                            borderLeft: 'none',
                                                            borderRight: 'none'
                                                        }}
                                                    >
                                                        Tổng chi phí thiết bị:{' '}
                                                        {totalAssetCost.toLocaleString(
                                                            'vi-VN'
                                                        )}{' '}
                                                        <small>đ</small>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>

                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="d-flex align-items-center">
                                            <span className="text-muted small italic mr-3">
                                                Tổng số: {rows.length} thiết bị
                                            </span>
                                            <Form.Group className="mb-0 d-flex align-items-center">
                                                <span className="text-muted small mr-2">
                                                    Hiển thị:
                                                </span>
                                                <Form.Control
                                                    as="select"
                                                    size="sm"
                                                    value={assetPageSize}
                                                    onChange={(e) => {
                                                        setAssetPageSize(
                                                            parseInt(
                                                                e.target.value
                                                            )
                                                        );
                                                        setAssetPage(1);
                                                    }}
                                                    style={{
                                                        width: '60px',
                                                        height: '28px',
                                                        fontSize: '11px',
                                                        padding: '2px 5px'
                                                    }}
                                                >
                                                    {pageSizeOptions.map(
                                                        (opt) => (
                                                            <option
                                                                key={opt.value}
                                                                value={
                                                                    opt.value
                                                                }
                                                            >
                                                                {opt.text}
                                                            </option>
                                                        )
                                                    )}
                                                </Form.Control>
                                            </Form.Group>
                                        </div>
                                        {rows.length > assetPageSize && (
                                            <div className="pagination-sm custom-pagination">
                                                <Pagination
                                                    activePage={assetPage}
                                                    itemsCountPerPage={
                                                        assetPageSize
                                                    }
                                                    totalItemsCount={
                                                        rows.length
                                                    }
                                                    pageRangeDisplayed={5}
                                                    onChange={(p) =>
                                                        setAssetPage(p)
                                                    }
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                />
                                            </div>
                                        )}
                                        {isEditing && (
                                            <BSButton
                                                variant="primary"
                                                size="sm"
                                                onClick={addRow}
                                            >
                                                <i className="fas fa-plus mr-1" />{' '}
                                                Thêm thiết bị cần sửa
                                            </BSButton>
                                        )}
                                    </div>
                                </div>
                            </Tab>
                            <Tab
                                eventKey="materials"
                                title={
                                    <span>
                                        <i className="fas fa-puzzle-piece mr-2 text-warning" />
                                        PHỤ KIỆN / VẬT TƯ ({materials.length})
                                    </span>
                                }
                            >
                                <div className="mt-2">
                                    {materials.length > 0 ? (
                                        <Table
                                            responsive
                                            bordered
                                            hover
                                            className="mb-0"
                                        >
                                            <thead
                                                className="bg-light text-secondary text-uppercase"
                                                style={{
                                                    fontSize: '11px',
                                                    letterSpacing: '0.5px'
                                                }}
                                            >
                                                <tr>
                                                    <th
                                                        className="text-center py-2"
                                                        style={{
                                                            width: '50px'
                                                        }}
                                                    >
                                                        #
                                                    </th>
                                                    <th className="py-2">
                                                        Tên vật tư / Phụ kiện
                                                    </th>
                                                    <th
                                                        className="text-center py-2"
                                                        style={{
                                                            width: '120px'
                                                        }}
                                                    >
                                                        Số lượng
                                                    </th>
                                                    <th
                                                        className="text-right py-2"
                                                        style={{
                                                            width: '160px'
                                                        }}
                                                    >
                                                        Đơn giá dự kiến
                                                    </th>
                                                    <th className="py-2">
                                                        Ghi chú
                                                    </th>
                                                    {isEditing && (
                                                        <th
                                                            className="text-center py-2"
                                                            style={{
                                                                width: '80px'
                                                            }}
                                                        >
                                                            Thao tác
                                                        </th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {materials
                                                    .slice(
                                                        (materialPage - 1) *
                                                            materialPageSize,
                                                        materialPage *
                                                            materialPageSize
                                                    )
                                                    .map((m, idx) => (
                                                        <tr key={m.id || idx}>
                                                            <td
                                                                className="text-center align-top pt-2 font-weight-light text-muted"
                                                                style={{
                                                                    fontSize:
                                                                        '12.5px'
                                                                }}
                                                            >
                                                                {idx +
                                                                    1 +
                                                                    (materialPage -
                                                                        1) *
                                                                        materialPageSize}
                                                            </td>
                                                            <td className="align-middle">
                                                                {isEditing ? (
                                                                    <React.Fragment>
                                                                        <Select
                                                                            options={
                                                                                catalogOptions
                                                                            }
                                                                            value={catalogOptions.find(
                                                                                (
                                                                                    o
                                                                                ) =>
                                                                                    o.value ===
                                                                                    m.materialCatalogId
                                                                            )}
                                                                            onChange={(
                                                                                opt
                                                                            ) =>
                                                                                updateMaterial(
                                                                                    m.id,
                                                                                    'materialCatalogId',
                                                                                    opt?.value
                                                                                )
                                                                            }
                                                                            placeholder="Chọn vật tư..."
                                                                            menuPortalTarget={
                                                                                document.body
                                                                            }
                                                                            styles={{
                                                                                control:
                                                                                    (
                                                                                        b
                                                                                    ) => ({
                                                                                        ...b,
                                                                                        minHeight:
                                                                                            '31px',
                                                                                        fontSize:
                                                                                            '12px',
                                                                                        borderColor:
                                                                                            errors
                                                                                                .materials?.[
                                                                                                idx
                                                                                            ]
                                                                                                ?.materialCatalogId
                                                                                                ? '#dc3545'
                                                                                                : b.borderColor,
                                                                                        '&:hover':
                                                                                            {
                                                                                                borderColor:
                                                                                                    errors
                                                                                                        .materials?.[
                                                                                                        idx
                                                                                                    ]
                                                                                                        ?.materialCatalogId
                                                                                                        ? '#dc3545'
                                                                                                        : b.borderColor
                                                                                            }
                                                                                    }),
                                                                                menuPortal:
                                                                                    (
                                                                                        base
                                                                                    ) => ({
                                                                                        ...base,
                                                                                        zIndex: 9999
                                                                                    })
                                                                            }}
                                                                        />
                                                                        {errors
                                                                            .materials?.[
                                                                            idx
                                                                        ]
                                                                            ?.materialCatalogId && (
                                                                            <div className="text-danger small mt-1">
                                                                                {
                                                                                    errors
                                                                                        .materials[
                                                                                        idx
                                                                                    ]
                                                                                        .materialCatalogId
                                                                                }
                                                                            </div>
                                                                        )}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <div
                                                                        className="fw-bold text-dark"
                                                                        style={{
                                                                            fontSize:
                                                                                '13.5px'
                                                                        }}
                                                                    >
                                                                        {m.materialName ||
                                                                            catalogOptions.find(
                                                                                (
                                                                                    c
                                                                                ) =>
                                                                                    c.value ===
                                                                                    m.materialCatalogId
                                                                            )
                                                                                ?.label ||
                                                                            'Vật tư'}
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td className="align-top pt-2 text-center">
                                                                {isEditing ? (
                                                                    <React.Fragment>
                                                                        <Form.Control
                                                                            type="number"
                                                                            size="sm"
                                                                            className="text-center"
                                                                            value={
                                                                                m.quantity
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                updateMaterial(
                                                                                    m.id,
                                                                                    'quantity',
                                                                                    parseInt(
                                                                                        e
                                                                                            .target
                                                                                            .value
                                                                                    ) ||
                                                                                        0
                                                                                )
                                                                            }
                                                                            isInvalid={
                                                                                !!errors
                                                                                    .materials?.[
                                                                                    idx
                                                                                ]
                                                                                    ?.quantity
                                                                            }
                                                                        />
                                                                        <Form.Control.Feedback
                                                                            type="invalid"
                                                                            className="small"
                                                                        >
                                                                            {
                                                                                errors
                                                                                    .materials?.[
                                                                                    idx
                                                                                ]
                                                                                    ?.quantity
                                                                            }
                                                                        </Form.Control.Feedback>
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <span
                                                                        className="badge bg-light border text-dark fw-normal px-3 py-1"
                                                                        style={{
                                                                            fontSize:
                                                                                '11px'
                                                                        }}
                                                                    >
                                                                        {
                                                                            m.quantity
                                                                        }
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td
                                                                className="align-top pt-2 text-right fw-bold text-danger"
                                                                style={{
                                                                    fontSize:
                                                                        '13.5px'
                                                                }}
                                                            >
                                                                {isEditing ? (
                                                                    <Form.Control
                                                                        type="number"
                                                                        size="sm"
                                                                        className="text-right"
                                                                        value={
                                                                            m.unitPrice
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            updateMaterial(
                                                                                m.id,
                                                                                'unitPrice',
                                                                                parseFloat(
                                                                                    e
                                                                                        .target
                                                                                        .value
                                                                                ) ||
                                                                                    0
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <>
                                                                        {m.unitPrice?.toLocaleString(
                                                                            'vi-VN'
                                                                        )}{' '}
                                                                        <small>
                                                                            đ
                                                                        </small>
                                                                    </>
                                                                )}
                                                            </td>
                                                            <td
                                                                className="align-middle text-muted"
                                                                style={{
                                                                    fontSize:
                                                                        '12.5px'
                                                                }}
                                                            >
                                                                {isEditing ? (
                                                                    <Form.Control
                                                                        type="text"
                                                                        size="sm"
                                                                        value={
                                                                            m.note
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            updateMaterial(
                                                                                m.id,
                                                                                'note',
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    m.note ||
                                                                    '—'
                                                                )}
                                                            </td>
                                                            {isEditing && (
                                                                <td className="text-center align-middle">
                                                                    <BSButton
                                                                        variant="link"
                                                                        className="text-danger p-0"
                                                                        title="Xóa"
                                                                        onClick={() =>
                                                                            removeMaterial(
                                                                                m.id
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="fas fa-trash-alt" />
                                                                    </BSButton>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    ))}
                                                {materials.length > 0 && (
                                                    <tr className="bg-light shadow-sm">
                                                        <td
                                                            colSpan={
                                                                isEditing
                                                                    ? 6
                                                                    : 5
                                                            }
                                                            className="text-center py-2 text-uppercase fw-bold"
                                                            style={{
                                                                fontSize:
                                                                    '15px',
                                                                color: '#dc2626',
                                                                borderLeft:
                                                                    'none',
                                                                borderRight:
                                                                    'none'
                                                            }}
                                                        >
                                                            Tổng chi phí vật tư
                                                            / phụ kiện:{' '}
                                                            {totalMaterialCost.toLocaleString(
                                                                'vi-VN'
                                                            )}{' '}
                                                            <small>đ</small>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    ) : (
                                        <div className="text-center py-4 bg-white border rounded text-muted italic">
                                            <i className="fas fa-info-circle mr-2" />
                                            Phiếu này không có vật tư / phụ kiện
                                            đi kèm
                                        </div>
                                    )}
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="d-flex align-items-center">
                                            <span className="text-muted small italic mr-3">
                                                Tổng số: {materials.length} vật
                                                tư
                                            </span>
                                            <Form.Group className="mb-0 d-flex align-items-center">
                                                <span className="text-muted small mr-2">
                                                    Hiển thị:
                                                </span>
                                                <Form.Control
                                                    as="select"
                                                    size="sm"
                                                    value={materialPageSize}
                                                    onChange={(e) => {
                                                        setMaterialPageSize(
                                                            parseInt(
                                                                e.target.value
                                                            )
                                                        );
                                                        setMaterialPage(1);
                                                    }}
                                                    style={{
                                                        width: '60px',
                                                        height: '28px',
                                                        fontSize: '11px',
                                                        padding: '2px 5px'
                                                    }}
                                                >
                                                    {pageSizeOptions.map(
                                                        (opt) => (
                                                            <option
                                                                key={opt.value}
                                                                value={
                                                                    opt.value
                                                                }
                                                            >
                                                                {opt.text}
                                                            </option>
                                                        )
                                                    )}
                                                </Form.Control>
                                            </Form.Group>
                                        </div>
                                        {materials.length >
                                            materialPageSize && (
                                            <div className="pagination-sm custom-pagination">
                                                <Pagination
                                                    activePage={materialPage}
                                                    itemsCountPerPage={
                                                        materialPageSize
                                                    }
                                                    totalItemsCount={
                                                        materials.length
                                                    }
                                                    pageRangeDisplayed={5}
                                                    onChange={(p) =>
                                                        setMaterialPage(p)
                                                    }
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                />
                                            </div>
                                        )}
                                        {isEditing && (
                                            <BSButton
                                                variant="outline-primary"
                                                size="sm"
                                                className="border-dashed py-2"
                                                style={{minWidth: '200px'}}
                                                onClick={addCommonMaterial}
                                            >
                                                <i className="fas fa-plus mr-1" />{' '}
                                                Thêm phụ kiện đi kèm
                                            </BSButton>
                                        )}
                                    </div>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </Card.Body>
                <Card.Footer className="bg-white text-muted small py-2 d-flex align-items-center">
                    <div className="mr-auto">
                        Hệ thống quản lý tài sản - Bệnh viện 108
                    </div>
                    <div className="font-italic">
                        <i className="fas fa-history mr-1" />
                        Cập nhật lần cuối:{' '}
                        <span className="text-dark fw-bold">
                            {formatDateTimeMoment(
                                data?.updatedDate || data?.createdDate
                            )}
                        </span>
                    </div>
                </Card.Footer>
            </Card>

            <style>{`
                .btn-icon-sm {
                    width: 26px;
                    height: 26px;
                    padding: 0;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 11px;
                    border-radius: 4px;
                }
                .custom-pagination .pagination {
                    margin-bottom: 0;
                    display: flex;
                    list-style: none;
                    gap: 4px;
                }
                .custom-pagination .page-item .page-link {
                    font-size: 12px;
                    padding: 0.25rem 0.6rem;
                    color: #4b5563;
                    border-radius: 4px;
                    border: 1px solid #e5e7eb;
                    text-decoration: none;
                    background-color: #fff;
                }
                .custom-pagination .page-item.active .page-link {
                    background-color: #3b82f6;
                    border-color: #3b82f6 !important;
                    color: white !important;
                }
                .custom-pagination .page-item.disabled .page-link {
                    color: #9ca3af;
                    pointer-events: none;
                    background-color: #f9fafb;
                }
                .bg-light-yellow {
                    transition: all 0.2s;
                }
                .shadow-xs {
                    box-shadow: 0 1px 2px rgba(0,0,0,0.02);
                }
                .custom-tabs-minimal .nav-link {
                    border: none;
                    color: #6c757d;
                    font-weight: 500;
                    padding: 10px 20px;
                }
                .custom-tabs-minimal .nav-link.active {
                    color: #007bff;
                    border-bottom: 2px solid #007bff;
                    background: transparent;
                }
                .table-bordered, .table, .table-bordered th, .table-bordered td {
                    border: 1px solid #6c757d !important;
                }
                .table {
                    border-top: 1px solid #6c757d !important;
                    border-collapse: separate !important;
                    border-spacing: 0;
                }
                .table thead th {
                    background-color: #f8f9fa;
                    border-bottom: 1px solid #6c757d !important;
                    border-top: 1px solid #6c757d !important;
                }
            `}</style>
            {/* Common Confirm Modal */}
            <Modal
                show={confirmModal.show}
                onHide={() => setConfirmModal({...confirmModal, show: false})}
                centered
            >
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="h6 fw-bold">
                        {confirmModal.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <i
                        className={`fas ${
                            confirmModal.icon || 'fa-exclamation-triangle'
                        } text-${confirmModal.type} fa-3x mb-3`}
                    />
                    <p className="mb-0 fw-bold">{confirmModal.message}</p>
                </Modal.Body>
                <Modal.Footer className="border-0 pb-3 justify-content-center">
                    <BSButton
                        variant="light"
                        className="px-4 shadow-sm"
                        onClick={() =>
                            setConfirmModal({...confirmModal, show: false})
                        }
                    >
                        Hủy
                    </BSButton>
                    <BSButton
                        variant={confirmModal.type}
                        className="px-4 shadow-sm"
                        onClick={() => {
                            if (confirmModal.onConfirm)
                                confirmModal.onConfirm();
                            setConfirmModal({...confirmModal, show: false});
                        }}
                    >
                        Xác nhận
                    </BSButton>
                </Modal.Footer>
            </Modal>

            {/* Modal Chọn Kết quả sửa chữa */}
            <Modal
                show={resultModal.show}
                onHide={() => setResultModal({...resultModal, show: false})}
                centered
                backdrop="static"
            >
                <Modal.Header closeButton className="bg-info text-white">
                    <Modal.Title className="h6 fw-bold">
                        <i className="fas fa-check-double mr-2" /> XÁC NHẬN KẾT
                        QUẢ SỬA CHỮA
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="py-4">
                    <Form.Group>
                        <Form.Label className="fw-bold text-dark small">
                            Vui lòng chọn kết quả sửa chữa cho{' '}
                            {resultModal.isBatch ? 'toàn bộ phiếu' : 'thiết bị'}{' '}
                            này:
                        </Form.Label>
                        <Select
                            options={repairResultOptions}
                            value={
                                repairResultOptions.find(
                                    (o) => o.value === selectedRepairResult
                                ) || repairResultOptions[0]
                            }
                            onChange={(opt) =>
                                setSelectedRepairResult(opt.value)
                            }
                            styles={resultSelectStyles}
                            menuPosition="fixed"
                            menuPortalTarget={document.body}
                            menuPlacement="bottom"
                            isSearchable={false}
                            placeholder="Chọn kết quả..."
                            classNamePrefix="select-result"
                            components={{
                                Option: (props) => (
                                    <components.Option {...props}>
                                        <div
                                            className="d-flex align-items-center"
                                            style={{
                                                color: props.isSelected
                                                    ? 'white'
                                                    : props.data.color,
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            <i
                                                className={`fas ${props.data.icon} mr-2`}
                                            />
                                            {props.data.label}
                                        </div>
                                    </components.Option>
                                ),
                                SingleValue: (props) => (
                                    <components.SingleValue {...props}>
                                        <div
                                            className="d-flex align-items-center"
                                            style={{
                                                color: props.data.color,
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            <i
                                                className={`fas ${props.data.icon} mr-2`}
                                            />
                                            {props.data.label}
                                        </div>
                                    </components.SingleValue>
                                )
                            }}
                        />
                        <div className="mt-3 p-3 bg-light rounded border">
                            <small className="text-muted d-block mb-1">
                                <i className="fas fa-info-circle mr-1" />{' '}
                                <strong>Ghi chú:</strong>
                            </small>
                            <ul className="mb-0 pl-3 small text-secondary">
                                <li>
                                    <strong>Thành công:</strong> Chuyển tài sản
                                    sang "Đang hoạt động".
                                </li>
                                <li>
                                    <strong>Thất bại:</strong> Chuyển tài sản
                                    sang "Hỏng ( Sửa chữa)".
                                </li>
                            </ul>
                        </div>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0">
                    <BSButton
                        variant="light"
                        onClick={() =>
                            setResultModal({...resultModal, show: false})
                        }
                    >
                        Hủy
                    </BSButton>
                    <BSButton
                        variant="info"
                        className="text-white fw-bold px-4"
                        onClick={handleFinalComplete}
                        disabled={
                            completeFunc.isLoading ||
                            completeBatchFunc.isLoading
                        }
                    >
                        {completeFunc.isLoading ||
                        completeBatchFunc.isLoading ? (
                            <i className="fas fa-spinner fa-spin mr-1" />
                        ) : (
                            <i className="fas fa-check mr-1" />
                        )}
                        Hoàn tất
                    </BSButton>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default MaintenanceBatchDetail;
